// extracted by mini-css-extract-plugin
export default {"box":"CheckBoxFormik_box__bAVoM","custom_checkbox":"CheckBoxFormik_custom_checkbox__P58dI","disabled":"CheckBoxFormik_disabled__zm0Ex"};